/*
* Created on Jan 08, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import React, {useState} from 'react'
import './static/css/app/app.css';
import './static/css/utils.css';
// import './static/css/app-custom.app.css';
import 'overlayscrollbars/styles/overlayscrollbars.css'
import MainHeaderComponent from "./component/main-header/MainHeaderComponent";
import {OrganizationProvider} from "./context/OrganizationContext";
import { BrowserRouter} from "react-router-dom";
import LandingPageComponent from "./component/landingPageComponent";
import MainContentIndexComponent from "./component/main-content/MainContentIndexComponent";
import {AuthSessionProvider, useAuthSession} from "./context/AuthSessionContext";
import {AlertProvider} from "./context/AlertContext";
import RegionProvider from "./context/RegionContext";
import {CountryListProvider} from "./context/CountryListContext";
import {GlobalConfigProvider} from "./context/GlobalConfigContext";
import MainFooterComponent from "./component/main-footer/MainFooterComponent";
import CookiesSettingProvider from "./context/CookiesSettingContext";


const App = () => {
    const access_token = sessionStorage.getItem('access_token');
    const [isLogin, setIsLogin] = useState(access_token);
    const [standalone, setStandalone] = useState(false);
    const [refresh, setRefresh] = useState(0);
    const [showFooter, setShowFooter] = useState(false);

    const NoLogin = () => {
        return (
            <OrganizationProvider>
                <BrowserRouter>
                    <div className="root common-page-root m--root common-page-root--landing">
                        <MainHeaderComponent organizations={[]}/>
                        <div className="wrap m--wrap">
                            { <LandingPageComponent /> }
                        </div>
                        <MainFooterComponent setShowFooter={setShowFooter}/>
                    </div>
                </BrowserRouter>
            </OrganizationProvider>
        )
    }

    const LoggedIn = () => {
        const {session} = useAuthSession();

        return (
            <OrganizationProvider>
                <BrowserRouter>
                    <div className={`root ${standalone ? 'common-page-root' : ''} m--root`}>
                        <MainHeaderComponent refresh={refresh}/>
                        <div className="wrap m--wrap">
                            { !session  && <LandingPageComponent/> }
                            { session && <MainContentIndexComponent setStandalone={setStandalone} refreshOrgList={setRefresh} setShowFooter={setShowFooter}/>}
                        </div>
                        { showFooter && <MainFooterComponent setShowFooter={setShowFooter}/>}
                    </div>
                </BrowserRouter>
            </OrganizationProvider>
        )
    }

    const StartingPage = () => {
        const {useCheckSession} = useAuthSession();
        useCheckSession(true)

        return (
            <>
                { !isLogin && isLogin === null && <div></div> /* prevent showing login page while checking session */}
                { !isLogin && isLogin !== null  && <NoLogin /> }
                { isLogin && <LoggedIn /> }
            </>
        )

    }

    return (
        <RegionProvider>
            <CountryListProvider>
            <GlobalConfigProvider>
                <AuthSessionProvider updateLogin={setIsLogin}>
                    <div id="modal-dialog" />
                    <CookiesSettingProvider>
                        <AlertProvider>
                            <StartingPage/>
                        </AlertProvider>
                    </CookiesSettingProvider>
                </AuthSessionProvider>
            </GlobalConfigProvider>
            </CountryListProvider>
        </RegionProvider>
    );
};

export default App;

